import * as React from 'react';

import { TAdBannerPlaceParameters } from '../../AdBannerMicrofrontendContainer';

/**
 * Константы места футерного баннера десктопной выдачи.
 *
 * Значения должны совпадать с легаси-размещением Adfox (AdfoxBannerFooterDesktop), чтобы
 * показывалась та же рекламная кампания: place — аналитическое место, pParams — p1/p2
 * размещения, sizes — размеры баннера.
 */
const PLACE = 'footer';
const P_PARAMS: TAdBannerPlaceParameters['pParams'] = { p1: 'dbtyp', p2: 'y' };
const SIZES: TAdBannerPlaceParameters['sizes'] = { width: '100%', height: 560 };

/**
 * Параметры места футерного баннера (десктопная выдача загородки).
 */
export function useFooterParameters(): TAdBannerPlaceParameters {
  return React.useMemo(
    (): TAdBannerPlaceParameters => ({
      place: PLACE,
      pParams: P_PARAMS,
      sizes: SIZES,
      position: null,
      galleryPosition: null,
      isSp: false,
      tgbNativedescGeneralDesign: null,
      carousel: null,
      deviceType: 'desktop',
    }),
    [],
  );
}
